<template>
  <div class="container">
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="title-single-box"><h1 class="title-single">Resources</h1>
              <span class="color-text-a">LASR Lab - Vanderbilt University Medical Center</span></div>
          </div>
          <div class="col-md-12 col-lg-4">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"
                                               class="router-link-active">Home</a></li>
                <li aria-current="page" class="breadcrumb-item active">
                  Resources
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="section-resources">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-t1">
            <div class="row">
              <div class="col-md-12">
                <ul>
                  <li v-for="l in links">
                    <a :href="l.link"
                         target="_blank">{{l.title}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Resources",
    data: function () {
      return {
        links: [{
          title: "VKC Autism Registry",
          link: "https://redcap.vanderbilt.edu/surveys/?s=F9NEE4DFXX"
        }, {
          title: "VKC StudyFinder",
          link: "https://vkc.vumc.org/studyfinder/"
        }, {
          title: "At Home Scan Practice",
          link: "https://www.youtube.com/watch?v=61BvBP6f5-E"
        }, {
          title: "Autism Society of Middle Tennessee",
          link: "https://autismtennessee.wildapricot.org/"
        }, {
          title: "Neuroscience For Kids",
          link: "https://faculty.washington.edu/chudler/introb.html"
        }, {
          title: "Your Brain and Nervous System",
          link: "https://kidshealth.org/en/kids/brain.html"
        }, {
          title: "NIH: Autism Spectrum Disorder",
          link: "https://www.nimh.nih.gov/health/topics/autism-spectrum-disorders-asd/index.shtml"
        }, {
          title: "Autism Speaks",
          link: "https://www.autismspeaks.org/"
        }, {
          title: "Teens Health : Autism Spectrum Disorder",
          link: "https://kidshealth.org/en/teens/autism.html"
        }, {
          title: "Know the ADA: Guide to Autism",
          link: "http://know-the-ada.com/t5/disabilities-guide-to-autism.html"
        }, {
          title: "Autism Now: Transition Planning for Students",
          link: "https://autismnow.org/in-the-classroom/transition-planning-for-students/"
        }, {
          title: "Autism Speaks Resource Guide",
          link: "https://www.autismspeaks.org/directory"
        }, {
          title: "Autistic Self Advocacy Network",
          link: "https://autisticadvocacy.org/resources/"
        }, {
          title: "Global and Regional Asperger Syndrome Partnership",
          link: "https://grasp.org/"
        }]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Resources.vue